const content = {
  state: {
    ERR_CODE: {
      SUCCESS: 200,
      SHOW_ERR_MSG_DIRECTLY: 0,
      QUESTION_IN_USE: 60080,
      PAPER_LOCKED: 60093,
      SAME_MAJOR_ENROLLED: 60189,
      SAME_MAJOR_TYPE_ENROLLED: 60190,
      PHONE_NOT_REG: 60097,
      GOODS_NOT_EXIST: 60098,
      CANT_GET_PLAY_AUTH: 600101,
      CANT_REG_DEGREE: 600100,
      EXAM_NOT_SUBMIT: 600102,
      NO_FREE_COURSE: 41007,
      USER_IS_INSTRUCTOR: 600105
    },
    ERR_MSG: {
      200: '请求成功',
      60023: '原密码不正确，请重新输入',
      60108: '用户名或手机号码已存在',
      60106: '邮箱已存在',
      60104: '手机号码已存在',
      60116: '用户名/手机号码和邮箱都已存在',
      60144: '课程名称已存在',
      60145: '课程代号已存在',
      60146: '课程名称和课程代号都已存在',
      60147: '课程分类已存在',
      60123: '更新章/节/单元失败',
      60124: '无效的课程ID',
      60011: '没有权限，课程团队更新失败',
      60012: '无效的课程分类ID',
      60017: '更新章/节/单元顺序失败',
      60018: '无效的教材ID',
      60019: '删除学生提交数据失败',
      60020: '重新评分失败',
      60021: '重置学生尝试次数失败',
      60086: '获取课程讲义失败',
      60089: '添加学籍失败',
      60090: '验证码已过期',
      60091: '验证码获取太频繁，请稍后再获取',
      60092: '验证码获取失败',
      60093: '该试卷正在被其他老师批改',
      60094: '导出失败，服务器繁忙中，请稍后再进行导出',
      60097: '手机号码未注册',
      60098: '考试费不存在',
      600103: '重置用户密码失败，请重新尝试',
      60189: '已报读相同专业',
      60190: '已报读相同类型专业',
      4033: '您没有权限删除用户',
      4044: '您的权限不足，不能添加APP启动广告页',
      4034: '您的权限不足，不能修改APP启动广告页',
      404: '请求无法找到',
      400: '校验失败，请检查您提交的数据',
      401: '您尚未登录或登录状态已超时，请重新登录',
      40003: '用户ID不合法',
      40061: '上传头像失败',
      40041: '请求失败，找不到对应的definitions',
      46004: '该用户不存在',
      40004: '媒体文件类型不合法',
      40032: '用户名/手机号码或密码不正确',
      40033: '该用户不存在',
      8047: '新旧密码相同',
      412: '相应的内容已经创建',
      41006: '无效的ID',
      41012: '该报考申请的审核已经通过，不允许修改报考类型',
      60066: 'fileMd5不能为空',
      60067: '无法获取文件锁拥有者',
      60068: '无法获取当前文件已上传的块数',
      60069: '当前文件已有人在上传,您暂无法上传该文件',
      60070: '用户名或手机号码不能为空',
      60080: '试题已在其他试卷中引用',
      41009: '更新的版本比目前正在使用的低，请重新操作',
      4032: '您的权限不足，不能发布APP版本',
      600100: '专科无法申请学位',
      600101: '无法获取播放凭证'
    }
  },
  mutations: {
  },
  actions: {}
}

export default content



// WEBPACK FOOTER //
// ./src/store/modules/errorMsg.js